import styled from 'styled-components';
export const Container = styled.div `
  display: flex;
  align-items: center;

  font-size: var(--font-size-300);
  letter-spacing: var(--font-letter-spacing-dense);
  color: var(--text-primary);
`;
